import home from '../assets/common/home.svg';
import { Link } from 'react-router-dom';

const Breadcrumbs = (props) => {
	const { data } = props;

	return (
		<div className='common-breadcrumbs'>
			<Link to='/' className='home'>
				<img src={home} alt='' />
			</Link>

			{data?.map((crumb) => {
				const { url, name, guid, route } = crumb;

				return (
					<div className='crumb' key={guid}>
						<div className='separator'></div>

						{url || route ? (
							<Link className='link' to={url || route}>
								{name}
							</Link>
						) : (
							<div className='path'>{name}</div>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default Breadcrumbs;
